import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import our Context
import { useAuth0 } from "@auth0/auth0-react";
import cookieJs from "js-cookie";
import { useContext, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useGetDetailes } from "../hooks/useGetDetailes";
import { UserContex } from "./App2";

export default function LogtedUserNavBar() {
  const [manualLogin, setManualLogin] = useState(false);
  const { user, logout } = useAuth0();
  const { userDetailes, loading } = useGetDetailes();
  const hasCookie = cookieJs.get("furniture_shop");

  const debounce = (func, delay) => {
    setTimeout(() => {
      func();
    }, delay);
  };
  const { dispatch } = useContext(UserContex);
  useEffect(() => {
    const toggleOpen = document.querySelector(".forToggleOpen");
    const toggleClose = document.querySelector(".forToggleClose");
    const header = document.querySelector(".header");
    const navbarLink = document.querySelectorAll(".navbarLink");
    toggleOpen.addEventListener("click", () => {
      header.classList.add("active");
    });
    toggleClose.addEventListener("click", () => {
      header.classList.remove("active");
    });
    navbarLink.forEach((element) => {
      element.addEventListener("click", () => {
        header.classList.remove("active");
      });
    });
    // console.log(navbarLink[0].class)
    return () => {
      toggleOpen.removeEventListener("click", () => {});
      toggleClose.removeEventListener("click", () => {});
    };
  });
  useEffect(() => {
    if (hasCookie) {
      setManualLogin(true);
    }
  }, [hasCookie]);

  const logoutFun = async () => {
    try {
      const cookie = cookieJs.get("furniture_shop");
      if (cookie) {
        cookieJs.remove("furniture_shop");
        toast.warning("Log Out Successful...🔥", {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });

        // debounce acctually it's not debouce 😁
        debounce(function () {
          // call  dispatch funtion
          dispatch({ type: "USER", payload: false });
        }, 2000);
      }
    } catch (err) {
      if (err) {
        toast.error("Log Out Failed❌❌!", {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    }
  };
  return (
    <>
      {!loading && manualLogin ? (
        <nav className="navbar navbar">
          <ul className="navbarUl">
            <li>
              <NavLink
                to="/home"
                className={({ isActive }) => (isActive ? "navLogInfo" : "")}
              >
                <span className="navbarLink home">home</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/about"
                className={({ isActive }) => (isActive ? "navLogInfo" : "")}
              >
                <span className="navbarLink about">about</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/service"
                className={({ isActive }) => (isActive ? "navLogInfo" : "")}
              >
                <span className="navbarLink service">service</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact"
                className={({ isActive }) => (isActive ? "navLogInfo" : "")}
              >
                <span className="navbarLink contactUs">contact us</span>
              </NavLink>
            </li>
            <li>
              {/* todo */}
              <div className="iconeHub">
                <img
                  src={`https://mahapravhu-furniture.vercel.app/uploads/${userDetailes.avatar}`}
                  className="userProfile "
                  alt="profile"
                />
                <span
                  className="material-symbols-outlined logoutIcone"
                  onClick={logoutFun}
                >
                  logout
                </span>
              </div>
              <span className="line"></span>
            </li>
          </ul>
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </nav>
      ) : (
        user && (
          <nav className="navbar navbar">
            <ul className="navbarUl">
              <li>
                <NavLink
                  to="/home"
                  className={({ isActive }) => (isActive ? "navLogInfo" : "")}
                >
                  <span className="navbarLink home">home</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/about"
                  className={({ isActive }) => (isActive ? "navLogInfo" : "")}
                >
                  <span className="navbarLink about">about</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/service"
                  className={({ isActive }) => (isActive ? "navLogInfo" : "")}
                >
                  <span className="navbarLink service">service</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/contact"
                  className={({ isActive }) => (isActive ? "navLogInfo" : "")}
                >
                  <span className="navbarLink contactUs">contact us</span>
                </NavLink>
              </li>
              <li>
                <div className="iconeHub">
                  <img
                    src={user.picture}
                    className="userProfile "
                    alt="profile"
                  />
                  <span
                    className="material-symbols-outlined logoutIcone"
                    onClick={logout}
                  >
                    logout
                  </span>
                </div>
                <span className="line"></span>
              </li>
            </ul>
            <ToastContainer
              position="top-center"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </nav>
        )
      )}
    </>
  );
}
